import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import DrawerButton from '../DrawerButton';

const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
`;

const Label = styled.span`
  font-size: 16px;
`;

function TemplatesDrawerHeader() {
  const templateUploadManager = store.creative?.templates.uploadManager;

  const showUploadTemplateModal = () => {
    if (templateUploadManager) templateUploadManager.modalVisible = true;
  };

  return (
    <Container>
      <Label>Templates</Label>
      <DrawerButton
        disabled={!templateUploadManager}
        onClick={showUploadTemplateModal}
      >
        Upload
      </DrawerButton>
    </Container>
  );
}

export default observer(TemplatesDrawerHeader);
